import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from 'v5/patterns/sidebar/Menu';

export type EnterpriseNewTeamMenuItemProps = {
  level?: number;
  onClick: () => void;
};

export function EnterpriseNewTeamMenuItem({
  level = 1,
  onClick
}: EnterpriseNewTeamMenuItemProps) {
  const { t } = useTranslation('core', { keyPrefix: 'enterprise' });

  return (
    <MenuItem
      level={level}
      className="text-fg-muted cursor-pointer"
      icon={<Plus className="size-4" />}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      {t('newTeam')}
    </MenuItem>
  );
}
